import { Fragment, lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./session-schedule.modal.container")
)

const Modal: FC = (): ReactElement => (
    <ErrorBoundary fallback={<Fragment />}>
        <ModalContainer modalId={EModalId.ScheduleSession} container={Container} />
    </ErrorBoundary>
)

export { Modal as SessionScheduleModal }
